const CheckboxSize = {
  Size14: 'size14',
  Size20: 'size20',
};

export default CheckboxSize;
